import { usePersistentState } from "@traas/lib/src/util/usePersistentState";
import React, {createContext, useContext, useMemo} from "react";
import {getDefaultDay} from "./util/datetime";
import moment, {Moment} from "moment";

export interface DateContextType {
  day: Date,
  momentDay: Moment,
  setDay: React.Dispatch<React.SetStateAction<Date>>
}

export interface DateContextProps {
  children: React.ReactNode
}

const DateContext = createContext<DateContextType>({} as DateContextType)

export const useSelectedDay = (): DateContextType => {
  return useContext(DateContext)
}


export const DateContextProvider = (props: DateContextProps) => {
  const [day, setDay] = usePersistentState<Date>('planner.selected_date', getDefaultDay())
  const momentDay = useMemo(() => moment(day), [day])

  const context: DateContextType = {
    day,
    momentDay,
    setDay,
  }
  return <DateContext.Provider value={context}>{props.children}</DateContext.Provider>
}